import { useEffect, useState } from 'react';

/**
 * テーブルページの状態管理用カスタムフック
 */
export const useStateTablePage = <T>(list: T) => {
	const [page, setPage] = useState(0); // ページインデックスの管理
	const [rowsPerPage, setRowsPerPage] = useState(20); // ページごとの行数の管理
	const [selectedRowIdx, setSelectedRowIdx] = useState(0); // 選択された検索結果のインデックスを管理

	useEffect(() => {
		setPage(0);
		setSelectedRowIdx(0);
	}, [list]);

	const handleChangePage = (event: unknown, newPage: number) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};

	const handleTableRowClick = (index: number) => {
		setSelectedRowIdx(index);
	};

	const isRowSelected = (index: number) => selectedRowIdx === index;

	return {
		page,
		rowsPerPage,
		handleChangePage,
		handleChangeRowsPerPage,
		handleTableRowClick,
		isRowSelected,
	};
};
